import {USER_REGISTER_MUTATION} from "../queries/user-register-mutation";
import { ApolloClient, InMemoryCache, gql, useMutation } from "@apollo/client";

import { Formik, Field, Form, FormikHelpers  } from "formik";
import MenuComponent from '../components/menu';
import User from "../components/user";


interface Values {
    password: string;
    emailAddress: string;
    title: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
  };


export default function register({categories}) {

    const [doregister, { error: cError, loading: cLoading }] = useMutation(
        USER_REGISTER_MUTATION
      );

    const formInitValues: Values = {
      password: "",
      emailAddress: "",
      title: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      };
    
      function onSuccess() {
        alert("Success");
          //window.location.reload(false);
    }
      const handleSubmit = async (
        values: Values,
        { setSubmitting, resetForm }: FormikHelpers<Values>
      ) => {
        setSubmitting(false);
        const resp = await doregister({ variables: values });
        if (!resp.errors) {
          resetForm();
          onSuccess();
        }
      }

  return (  
    <div className="container-fluid">
    <div><h2>Im Shop registrieren</h2></div>
    <div className="flex-row-reverse">
      <User></User>
      <a href="../cart"><div><i className="bi-cart"></i></div></a>
    </div>
    <div className="row container-fluid">
    <div className="col-md-6 borderbox checkout1">
    <Formik initialValues={formInitValues} onSubmit={handleSubmit}>
            <Form>
            <div className="mb-3">    
            <label htmlFor="xEmail1" className="form-label">E-Mail</label>   
            <Field className="form-control" id="xEmail1" name="emailAddress" type="text" />
            </div>
            <div className="mb-3">    
            <label htmlFor="xPassword1" className="form-label">Passwort</label>   
            <Field className="form-control" id="xPassword1" name="password" type="password" />
            </div>
            <div className="mb-3">    
            <label htmlFor="Anrede1" className="form-label-sm">Anrede</label>   
            <Field as="select" className="form-control" id="Anrede1" name="title">
             <option value="">Bitte auswählen</option>
             <option value="Frau">Frau</option>
             <option value="Herr">Herr</option>
             <option value="">keine Angabe</option>
            </Field>
            </div>
            <div className="mb-3">    
            <label htmlFor="firstName1" className="form-label">Vorname</label>   
            <Field className="form-control" id="firstName1" name="firstName" type="text" />
            </div>
            <div className="mb-3">    
            <label htmlFor="Nachname1" className="form-label">Nachname</label>   
            <Field className="form-control" id="Nachname1" name="lastName" type="text" />
            </div>
            <div className="mb-3">    
            <label htmlFor="Telefonnummer1" className="form-label">Telefonnummer</label>   
            <Field className="form-control" id="Telefonnummer1" name="phoneNumber" type="tel" />
            </div>
            <button className="btn btn-primary" type="submit">Registrieren</button>
            
            </Form>
    </Formik>
    </div>
    <div className="col-md-6"></div>
    </div>    
    </div>
  );


}